/**
 * Вернет **первое** определенное значение из объекта
 * перебирая список переданных путей
 *
 * @param {object} obj - объект в котором искать
 * @param {string[]} paths - список путей `['a.b.c.d', 'a.c.n', 'b.r']`
 * @param {any=} defaultValue - значение по умолчанию
 * @returns {any=}
 */
export const getByPathPriority = (obj = {}, paths = [], defaultValue) => {
    let result;

    for (const path of paths) {
        const keys = path.split(".");

        let pathValue = obj;

        for (const key of keys) {
            pathValue = pathValue[key];
            if (pathValue === undefined) break;
        }

        if (result !== undefined) break;

        result = pathValue;
    }

    return result ?? defaultValue;
};
